import { render, staticRenderFns } from "./bookReviewListOrg.vue?vue&type=template&id=afc4f8b0&scoped=true&"
import script from "./bookReviewListOrg.vue?vue&type=script&lang=js&"
export * from "./bookReviewListOrg.vue?vue&type=script&lang=js&"
import style0 from "./bookReviewListOrg.vue?vue&type=style&index=0&id=afc4f8b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc4f8b0",
  null
  
)

export default component.exports